// Centralized luxury travel content for Travwave
export const DESTINATIONS = [
  {
    name: "Maldives",
    slug: "maldives",
    image: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?q=80&w=1600&auto=format&fit=crop",
    price: "₹1,85,000",
    duration: "6 Nights",
    tagline: "Overwater villas & turquoise lagoons",
  },
  {
    name: "Bali",
    slug: "bali",
    image: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?q=80&w=1600&auto=format&fit=crop",
    price: "₹78,000",
    duration: "7 Nights",
    tagline: "Cliffside villas & jungle retreats",
  },
  {
    name: "Dubai",
    slug: "dubai",
    image: "https://images.unsplash.com/photo-1518684079-3c830dcef090?q=80&w=1600&auto=format&fit=crop",
    price: "₹95,000",
    duration: "5 Nights",
    tagline: "Skylines, sand dunes & opulence",
  },
  {
    name: "Japan",
    slug: "japan",
    image: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?q=80&w=1600&auto=format&fit=crop",
    price: "₹2,10,000",
    duration: "9 Nights",
    tagline: "Cherry blossoms & ryokan stays",
  },
  {
    name: "Thailand",
    slug: "thailand",
    image: "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?q=80&w=1600&auto=format&fit=crop",
    price: "₹68,000",
    duration: "6 Nights",
    tagline: "Island hopping in paradise",
  },
  {
    name: "Singapore",
    slug: "singapore",
    image: "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?q=80&w=1600&auto=format&fit=crop",
    price: "₹82,000",
    duration: "5 Nights",
    tagline: "Garden city of the future",
  },
  {
    name: "Vietnam",
    slug: "vietnam",
    image: "https://images.unsplash.com/photo-1528127269322-539801943592?q=80&w=1600&auto=format&fit=crop",
    price: "₹72,000",
    duration: "7 Nights",
    tagline: "Halong Bay & ancient temples",
  },
  {
    name: "Turkey",
    slug: "turkey",
    image: "https://images.unsplash.com/photo-1641128324972-af3212f0f6bd?q=80&w=1600&auto=format&fit=crop",
    price: "₹1,15,000",
    duration: "8 Nights",
    tagline: "Cappadocia balloons & Istanbul",
  },
  {
    name: "South Korea",
    slug: "south-korea",
    image: "https://images.pexels.com/photos/18495179/pexels-photo-18495179.jpeg",
    price: "₹1,45,000",
    duration: "7 Nights",
    tagline: "Seoul nights & palace mornings",
  },
  {
    name: "Europe",
    slug: "europe",
    image: "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?q=80&w=1600&auto=format&fit=crop",
    price: "₹2,45,000",
    duration: "10 Nights",
    tagline: "Multi-country grand tour",
  },
];

export const PACKAGES = [
  {
    id: "p1",
    name: "Maldives Overwater Escape",
    image: "https://images.unsplash.com/photo-1573843981267-be1999ff37cd?q=80&w=1600&auto=format&fit=crop",
    duration: "6 Nights · 7 Days",
    price: "₹1,85,000",
    inclusions: ["Flights", "Visa", "Hotels", "Meals"],
    rating: 4.9,
  },
  {
    id: "p2",
    name: "Bali Cliffside Honeymoon",
    image: "https://images.unsplash.com/photo-1604999333679-b86d54738315?q=80&w=1600&auto=format&fit=crop",
    duration: "7 Nights · 8 Days",
    price: "₹98,500",
    inclusions: ["Flights", "Hotels", "Meals"],
    rating: 4.8,
  },
  {
    id: "p3",
    name: "Swiss Alps Signature",
    image: "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?q=80&w=1600&auto=format&fit=crop",
    duration: "8 Nights · 9 Days",
    price: "₹2,75,000",
    inclusions: ["Flights", "Visa", "Hotels", "Meals"],
    rating: 5.0,
  },
  {
    id: "p4",
    name: "Dubai Desert & Skyline",
    image: "https://images.pexels.com/photos/13256066/pexels-photo-13256066.jpeg",
    duration: "5 Nights · 6 Days",
    price: "₹1,05,000",
    inclusions: ["Flights", "Visa", "Hotels"],
    rating: 4.7,
  },
  {
    id: "p5",
    name: "Kyoto Sakura Ryokan",
    image: "https://images.unsplash.com/photo-1492571350019-22de08371fd3?q=80&w=1600&auto=format&fit=crop",
    duration: "9 Nights · 10 Days",
    price: "₹2,40,000",
    inclusions: ["Flights", "Visa", "Hotels", "Meals"],
    rating: 4.9,
  },
  {
    id: "p6",
    name: "Santorini Aegean Romance",
    image: "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?q=80&w=1600&auto=format&fit=crop",
    duration: "7 Nights · 8 Days",
    price: "₹2,15,000",
    inclusions: ["Flights", "Visa", "Hotels", "Meals"],
    rating: 4.9,
  },
];

export const WHY_CHOOSE = [
  { icon: "UserRound", title: "Personal Travel Consultant", text: "A dedicated expert curates every detail of your journey, from first inquiry to homecoming." },
  { icon: "Stamp", title: "End-to-end Visa Assistance", text: "Document review, embassy appointments and approval — handled by our specialists." },
  { icon: "Sparkles", title: "Bespoke Itineraries", text: "Every itinerary is hand-crafted around your pace, palate and passions." },
  { icon: "BadgeIndianRupee", title: "Best Price Guarantee", text: "We pre-negotiate exclusive rates with premium partners worldwide." },
  { icon: "LifeBuoy", title: "24×7 On-Trip Support", text: "Our concierge desk is reachable around the clock, in every timezone." },
  { icon: "Globe2", title: "Local Partners Worldwide", text: "Trusted ground partners in 25+ countries — for seamless, on-the-ground experiences." },
];

export const COLLECTIONS = [
  { name: "Honeymoon Escapes", image: "https://images.unsplash.com/photo-1542718610-a1d656d1884c?q=80&w=1600&auto=format&fit=crop", count: "42 journeys" },
  { name: "Private Villas", image: "https://images.unsplash.com/photo-1582719508461-905c673771fd?q=80&w=1600&auto=format&fit=crop", count: "120+ villas" },
  { name: "Luxury Cruises", image: "https://images.unsplash.com/photo-1599640842225-85d111c60e6b?q=80&w=1600&auto=format&fit=crop", count: "18 lines" },
  { name: "Family Holidays", image: "https://images.pexels.com/photos/34120054/pexels-photo-34120054.jpeg", count: "65 journeys" },
  { name: "Adventure Tours", image: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606?q=80&w=1600&auto=format&fit=crop", count: "30 expeditions" },
  { name: "Corporate Incentives", image: "https://images.unsplash.com/photo-1556761175-4b46a572b786?q=80&w=1600&auto=format&fit=crop", count: "Bespoke" },
];

export const TESTIMONIALS = [
  {
    name: "Aarav & Sanya Mehta",
    trip: "Maldives Honeymoon",
    quote: "Every touchpoint felt thoughtfully orchestrated. The overwater villa, the private dinner under the stars — Travwave didn't plan our honeymoon, they composed it.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=400&auto=format&fit=crop",
    rating: 5,
  },
  {
    name: "Rohan Kapoor",
    trip: "Swiss Alps Family Tour",
    quote: "A four-generation family trip with zero hiccups. Our consultant anticipated needs we didn't know we had. Travwave has spoiled us for any other travel company.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=400&auto=format&fit=crop",
    rating: 5,
  },
  {
    name: "Priya Iyer",
    trip: "Japan Sakura Trail",
    quote: "Boarding a ryokan in Kyoto during peak bloom is impossible — except Travwave made it happen. The itinerary felt like a love letter to Japan.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=400&auto=format&fit=crop",
    rating: 5,
  },
  {
    name: "Vikram Singh",
    trip: "Dubai Corporate Retreat",
    quote: "Hosted 80 of our top performers in Dubai. Logistics were flawless and the desert gala was unforgettable. We've already booked next year with them.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=400&auto=format&fit=crop",
    rating: 5,
  },
];

export const VISA_COUNTRIES = [
  { name: "USA", flag: "🇺🇸", processing: "15-21 days", price: "₹15,500" },
  { name: "Canada", flag: "🇨🇦", processing: "10-14 days", price: "₹14,200" },
  { name: "United Kingdom", flag: "🇬🇧", processing: "10-15 days", price: "₹16,800" },
  { name: "Australia", flag: "🇦🇺", processing: "20-28 days", price: "₹18,500" },
  { name: "Schengen", flag: "🇪🇺", processing: "10-15 days", price: "₹12,000" },
  { name: "Japan", flag: "🇯🇵", processing: "5-7 days", price: "₹8,500" },
  { name: "Thailand", flag: "🇹🇭", processing: "3-5 days", price: "₹4,200" },
  { name: "Singapore", flag: "🇸🇬", processing: "3-5 days", price: "₹4,800" },
  { name: "Dubai", flag: "🇦🇪", processing: "3-4 days", price: "₹6,500" },
  
];

export const BLOGS = [
  { title: "The Insider's Guide to Bali's Hidden Cliffside Villas", excerpt: "Beyond Seminyak — the secluded sanctuaries our concierges actually book for honeymooners.", tag: "Bali Guide", image: "https://images.unsplash.com/photo-1518544801976-3e159e50e5bb?q=80&w=1600&auto=format&fit=crop", read: "8 min read" },
  { title: "Thailand on a Premium Budget: The 7-Night Sweet Spot", excerpt: "How to balance Bangkok, Phuket and Koh Samui without compromising on luxury.", tag: "Thailand", image: "https://images.unsplash.com/photo-1506665531195-3566af2b4dfa?q=80&w=1600&auto=format&fit=crop", read: "6 min read" },
  { title: "Chasing Cherry Blossoms: A Week-by-Week Japan Forecast", excerpt: "Timing sakura season is an art. Here's our concierge calendar for 2026.", tag: "Japan", image: "https://images.unsplash.com/photo-1480796927426-f609979314bd?q=80&w=1600&auto=format&fit=crop", read: "10 min read" },
  { title: "Europe in Summer: Five Less-Touristy Routes for 2026", excerpt: "Skip the Eiffel queue. Our private routes through Slovenia, Croatia and Portugal.", tag: "Europe", image: "https://images.unsplash.com/photo-1473951574080-01fe45ec8643?q=80&w=1600&auto=format&fit=crop", read: "12 min read" },
  { title: "Dubai Visa 2026: What's Changed and What to Expect", excerpt: "Our visa team breaks down the latest UAE entry rules in plain English.", tag: "Visa", image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=1600&auto=format&fit=crop", read: "5 min read" },
  { title: "Singapore with Kids: A Five-Night Family Blueprint", excerpt: "From Sentosa to Sanctuary stays — our most-requested family itinerary, unpacked.", tag: "Family", image: "https://images.unsplash.com/photo-1567360425618-1594206637d2?q=80&w=1600&auto=format&fit=crop", read: "7 min read" },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Destinations", to: "/destinations" },
  { label: "Visa Services", to: "/visa" },
  { label: "Luxury Holidays", to: "/luxury" },
  { label: "Corporate Travel", to: "/corporate" },
  { label: "Blogs", to: "/blogs" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const WHATSAPP_NUMBER = "9622469097"; // placeholder
